import React, { useLayoutEffect, useRef, useState, ReactNode, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MetaDecorator, Button, Icon, FlexContainer, Flex, Toast, Panel, LoaderDots, Overlay, ModalSheet } from "../../components";
import Parallax from 'parallax-js';
import { isSafari, isMobile } from "react-device-detect";
import moment from 'moment';

// import { SwapForm } from "../layouts";
import classnames from "classnames/bind";
import styles from "./Token.module.scss";
import { Info } from "../../interfaces";

import DeBotClient from "../../client/client";

const cnb = classnames.bind(styles);

const DebotQrCode = () => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg"x="0px" y="0px" width="72" height="72" viewBox="0 0 72 72" fill="currentColor">
    <g>
      <path d="M14.9,0C14.4,0,14,0.4,14,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9V0.9C15.8,0.4,15.4,0,14.9,0z"/>
      <path d="M39.5,1.8c0.5,0,0.9-0.4,0.9-0.9C40.4,0.4,40,0,39.5,0c-0.5,0-0.9,0.4-0.9,0.9C38.6,1.4,39,1.8,39.5,1.8z"/>
      <path d="M53.6,1.8c0.5,0,0.9-0.4,0.9-0.9C54.4,0.4,54,0,53.6,0c-0.5,0-0.9,0.4-0.9,0.9C52.7,1.4,53.1,1.8,53.6,1.8z"/>
      <path d="M57.1,1.8c0.5,0,0.9-0.4,0.9-0.9C58,0.4,57.6,0,57.1,0c-0.5,0-0.9,0.4-0.9,0.9C56.2,1.4,56.6,1.8,57.1,1.8z"/>
      <path d="M71.9,0.5c-0.1-0.2-0.2-0.3-0.4-0.4C71.2,0,71,0,70.4,0h-0.2h-1.8h-1.8H65h-1.8h-1.8h-0.2
        c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2v1.8v1.8V7v1.8v1.8v0.2c0,0.6,0,0.8,0.1,1.1
        c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2h1.8H65h1.8h1.8h1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4
        c0.1-0.2,0.1-0.5,0.1-1.1v-0.2V8.8V7V5.3V3.5V1.8V1.6C72,1,72,0.8,71.9,0.5z M70.2,3.5v1.8V7v1.8v1.8h-1.8h-1.8H65h-1.8h-1.8V8.8V7
        V5.3V3.5V1.8h1.8H65h1.8h1.8h1.8V3.5z"/>
      <path d="M17.6,1.8h-1.8v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2h1.8V1.8H17.6z"
        />
      <path d="M31.6,5.3h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1V3.5h1.8v1.8v0.2
        c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4C35.9,7,36.2,7,36.7,7h0.2V5.3V3.5V3.4c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4
        c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2V0.9c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9v0.9h-1.8v1.8V5.3z"/>
      <path d="M39.5,3.5c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9h0.9V4.4C40.4,3.9,40,3.5,39.5,3.5z"/>
      <path d="M67.9,3.6c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2H65h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4
        c-0.1,0.2-0.1,0.5-0.1,1.1v0.2V7v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1H65h1.8h0.2
        c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1V7V5.3V5.1c0-0.6,0-0.8-0.1-1.1C68.3,3.9,68.1,3.7,67.9,3.6z
        "/>
      <path d="M14.9,5.3c-0.5,0-0.9,0.4-0.9,0.9S14.4,7,14.9,7h0.9V6.1C15.8,5.7,15.4,5.3,14.9,5.3z"/>
      <path d="M21.1,7h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1V5.3V3.5h1.8v0.9
        c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9V3.5V1.8h1.8h1.8h1.8V1.6c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4
        C30.8,0,30.6,0,30,0h-0.2h-1.8h-1.8h-1.8h-1.8h-1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1
        v0.2h1.8v1.8h-1.8v1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1V7h1.8H21.1z"/>
      <path d="M29.9,5.3V4.4c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.9v0.2c0,0.6,0,0.8,0.1,1.1
        c0.1,0.2,0.2,0.3,0.4,0.4C28.9,7,29.1,7,29.7,7h0.2h1.8V5.3H29.9z"/>
      <path d="M50.9,7V5.3h-1.8V5.1c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2V1.8V1.6
        c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4C46.7,0,46.4,0,45.8,0h-0.2h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4
        c-0.1,0.2-0.1,0.5-0.1,1.1v0.2H43c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9h1.8v0.2c0,0.6,0,0.8,0.1,1.1
        c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2V7h1.8H50.9z"/>
      <path d="M52.7,7h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1V5.3h1.8h0.9
        c0.5,0,0.9-0.4,0.9-0.9s-0.4-0.9-0.9-0.9h-0.9h-1.8h-1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4
        c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h1.8V7z"/>
      <path d="M4.1,8.7c0.2,0.1,0.5,0.1,1.1,0.1h0.2H7h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4
        C8.8,8,8.8,7.7,8.8,7.2V7V5.3V5.1c0-0.6,0-0.8-0.1-1.1C8.6,3.9,8.4,3.7,8.2,3.6C8,3.5,7.7,3.5,7.2,3.5H7H5.3H5.1
        c-0.6,0-0.8,0-1.1,0.1C3.9,3.7,3.7,3.9,3.6,4.1C3.5,4.3,3.5,4.6,3.5,5.1v0.2V7v0.2c0,0.6,0,0.8,0.1,1.1C3.7,8.4,3.9,8.6,4.1,8.7z"
        />
      <path d="M33.4,8.6c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4C32.6,7,32.3,7,31.8,7h-0.2v1.8h1.8V8.6z"/>
      <path d="M50.9,8.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2v1.8V14h1.8v1.8
        h-1.8V14h-1.8v-1.8v-0.2c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v1.8h-1.8V14h1.8v1.8h1.8v1.8
        h1.8v1.8v1.8H49c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h1.8V23c0,0.6,0,0.8,0.1,1.1
        c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v-1.8h1.8h1.8v-1.8h1.8H58v-0.2c0-0.6,0-0.8-0.1-1.1
        c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2h-1.8h-1.8h-1.8v-1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4
        c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1V14h-1.8v-1.8h-1.8v-1.8
        h1.8v1.8h1.8v-1.8h1.8v-0.2c0-0.6,0-0.8-0.1-1.1C56,9.1,55.8,9,55.6,8.9c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2h-1.8V7h-1.8V8.8z"/>
      <path d="M17.6,10.5V8.8V7h-1.8v1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4C14,9.5,14,9.8,14,10.4v0.2v0.2
        c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v-1.8H17.6z"/>
      <path d="M21.1,9.7c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.9h1.8V9.7z"/>
      <path d="M35.1,8.8h-1.8v1.8h1.8v0.9c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-0.9h1.8v1.8v0.2c0,0.6,0,0.8,0.1,1.1
        c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2h1.8v-1.8h-1.8v-1.8v-0.2c0-0.6,0-0.8-0.1-1.1C40.2,9.1,40,9,39.8,8.9
        c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2V8.6c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4C37.9,7,37.6,7,37,7h-0.2v1.8H35.1z"/>
      <path d="M0.5,12.2c0.2,0.1,0.5,0.1,1.1,0.1h0.2h1.8h1.8H7h1.8h1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4
        c0.1-0.2,0.1-0.5,0.1-1.1v-0.2V8.8V7V5.3V3.5V1.8V1.6c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4C11.5,0,11.3,0,10.7,0h-0.2H8.8
        H7H5.3H3.5H1.8H1.6C1,0,0.8,0,0.5,0.1C0.4,0.2,0.2,0.4,0.1,0.5C0,0.8,0,1,0,1.6v0.2v1.8v1.8V7v1.8v1.8v0.2c0,0.6,0,0.8,0.1,1.1
        C0.2,11.9,0.4,12.1,0.5,12.2z M1.8,8.8V7V5.3V3.5V1.8h1.8h1.8H7h1.8h1.8v1.8v1.8V7v1.8v1.8H8.8H7H5.3H3.5H1.8V8.8z"/>
      <rect x="17.6" y="10.5" width="1.8" height="1.8"/>
      <path d="M22,12.3c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9v1.8H22z"/>
      <path d="M25.5,10.5c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9v-1.8H25.5z"/>
      <path d="M28.1,12.3h1.8v-1.8h1.8V8.8h-1.8h-1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4
        c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h1.8V12.3z"/>
      <path d="M31.6,12.3h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h-1.8V12.3z"/>
      <path d="M43.9,10.5h1.8V8.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1V7h-1.8h-1.8V6.9
        c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2h-1.8v0.2c0,0.6,0,0.8,0.1,1.1
        c0.1,0.2,0.2,0.3,0.4,0.4C41.2,7,41.4,7,42,7h0.2v1.8v1.8v1.8h1.8V10.5z"/>
      <path d="M57.1,12.3c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9v1.8H57.1z"/>
      <rect x="19.3" y="12.3" width="1.8" height="1.8"/>
      <path d="M28.1,12.3h-1.8V14v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2V14V12.3z"/>
      <path d="M29.9,12.4c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v-1.8h-1.8V12.4z"/>
      <rect x="54.4" y="12.3" width="1.8" height="1.8"/>
      <path d="M21.2,15.3c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2h0.9c0.5,0,0.9-0.4,0.9-0.9
        c0-0.5-0.4-0.9-0.9-0.9h-0.9h-1.8v0.2C21.1,14.8,21.1,15,21.2,15.3z"/>
      <path d="M31.7,15.3c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v-0.2c0-0.6,0-0.8-0.1-1.1
        c-0.1-0.2-0.2-0.3-0.4-0.4C32.6,14,32.3,14,31.8,14h-0.2v0.2C31.6,14.8,31.6,15,31.7,15.3z"/>
      <path d="M36.9,14.9c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9v0.9h1.8V14.9z"/>
      <path d="M56.3,15.3c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1H58V16c0,0.6,0,0.8,0.1,1.1
        c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v-1.8v-0.2c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4
        C58.9,14,58.7,14,58.1,14H58h-1.8v0.2C56.2,14.8,56.2,15,56.3,15.3z"/>
      <path d="M63.2,14.9c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9
        C62.8,15.8,63.2,15.4,63.2,14.9z"/>
      <path d="M65.9,14c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9v-0.9C66.7,14.4,66.3,14,65.9,14z"/>
      <path d="M71.1,14c-0.5,0-0.9,0.4-0.9,0.9v0.9h-1.8h-1.8v1.8h-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9
        h1.8v1.8h1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4C72,20.3,72,20,72,19.5v-0.2v-1.8v-1.8v-0.9C72,14.4,71.6,14,71.1,14
        z"/>
      <path d="M29.9,16.7c0-0.5-0.4-0.9-0.9-0.9h-0.9v1.8H29C29.5,17.6,29.9,17.2,29.9,16.7z"/>
      <path d="M37.8,17.6c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9v1.8H37.8z"/>
      <polygon points="45.7,17.6 45.7,15.8 43.9,15.8 43.9,14 42.1,14 42.1,15.8 42.1,17.6 43.9,17.6 	"/>
      <path d="M22,17.6c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9v-0.9C22.8,18,22.4,17.6,22,17.6z"/>
      <path d="M33.4,19.3h-1.8h-1.8h-1.8v-1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1
        v0.2v1.8h-1.8v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2h0.2c0.6,0,0.8,0,1.1-0.1
        c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h1.8h1.8v1.8h1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4
        c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2v-1.8h-1.8v-1.8h-1.8
        v1.8V19.3z"/>
      <path d="M42.1,17.6H42c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h1.8V17.6z"/>
      <path d="M45.7,18.4c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.9h-1.8V18.4z"/>
      <path d="M24.5,19.9c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v0.2c0,0.6,0,0.8,0.1,1.1
        c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v-0.2C24.6,20.4,24.6,20.1,24.5,19.9z"/>
      <path d="M43,21.1c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9v1.8H43z"/>
      <path d="M11.4,22.8c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9v1.8H11.4z"/>
      <path d="M18.4,21.1c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9V22C19.3,21.5,18.9,21.1,18.4,21.1z"/>
      <path d="M40.4,21.1v-1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2v1.8h1.8
        h1.8v-1.8H40.4z"/>
      <path d="M65,21.1h-1.8h-1.8v-1.8h0.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9h-1.8v1.8v1.8H58v0.2
        c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2h1.8h1.8v1.8v0.2c0,0.6,0,0.8,0.1,1.1
        c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1H65v-1.8h1.8v1.8H65v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4
        c0.2,0.1,0.5,0.1,1.1,0.1h0.2v1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4C65,30.6,65,30.9,65,31.5v0.2h-1.8h-1.8h-1.8
        v1.8v1.8v1.8v1.8H58v-1.8V36c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.9H56c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4
        c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h1.8v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1H58h1.8h1.8v-1.8v-1.8
        h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2H65h1.8v-1.8v-1.8h1.8v-1.8h0.2
        c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2v-1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4
        c0.1-0.2,0.1-0.5,0.1-1.1v-0.2v-0.9c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.9h-1.8v-1.8v-1.8h-1.8H65z"/>
      <path d="M20.2,22.8h-0.9v0.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9C21.1,23.2,20.7,22.8,20.2,22.8z"/>
      <path d="M29.9,23.7c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.9h-0.9C30.2,22.8,29.9,23.2,29.9,23.7z"/>
      <path d="M36.9,23.7c0,0.5,0.4,0.9,0.9,0.9h0.9v-1.8h-0.9C37.3,22.8,36.9,23.2,36.9,23.7z"/>
      <path d="M56.2,24.6v-0.2c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v1.8H56.2z"/>
      <path d="M11.4,26.3c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9v0.9C10.5,25.9,10.9,26.3,11.4,26.3z"/>
      <path d="M27.2,26.3c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9h-0.2c-0.6,0-0.8,0-1.1,0.1
        c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h1.8H27.2z"/>
      <path d="M39.5,26.3c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9v0.9C38.6,25.9,39,26.3,39.5,26.3z"/>
      <path d="M52.7,26.3v1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2v-1.8h-1.8h-1.8
        v1.8H52.7z"/>
      <path d="M57.1,26.3c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9v0.9C56.2,25.9,56.6,26.3,57.1,26.3z"/>
      <path d="M14,28.1h-1.8h-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9v1.8h-1.8h-0.2c-0.6,0-0.8,0-1.1,0.1
        C9.1,31.8,9,32,8.9,32.2c-0.1,0.2-0.1,0.5-0.1,1.1v0.2v1.8h1.8v-1.8h1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4
        c0.1-0.2,0.1-0.5,0.1-1.1v-0.2v-1.8h1.8v-1.8H14z"/>
      <path d="M50.9,29.9h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h-1.8V29.9z"/>
      <path d="M59.9,29.9c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2v-0.9
        c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.9h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4C58,28.9,58,29.1,58,29.7
        v0.2V30c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v-1.8H59.9z"/>
      <path d="M5.3,31.6h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4C7,30.8,7,30.6,7,30v-0.2h0.9
        c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9H7v-1.8v-1.8h1.8h1.8v-1.8H8.8v-1.8h1.8v-1.8h1.8H14v1.8v1.8v1.8v0.2
        c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v1.8h1.8h1.8v-0.2c0-0.6,0-0.8-0.1-1.1
        c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v-0.2c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4
        c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v-1.8v-1.8v-1.8h1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2
        v-1.8V14h-1.8v-1.8h-1.8V14h-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9v1.8H14h-1.8h-1.8v-1.8h0.9
        c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1
        v0.2v1.8H7v-0.2c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1H5.3H5.1c-0.6,0-0.8,0-1.1,0.1
        c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2H1.8H1.6c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4
        C0,18.3,0,18.6,0,19.2v0.2v0.9c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-0.9h1.8v1.8v1.8H1.8H1.6c-0.6,0-0.8,0-1.1,0.1
        c-0.2,0.1-0.3,0.2-0.4,0.4C0,23.6,0,23.9,0,24.4v0.2v1.8v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1
        h0.2h1.8v-1.8h1.8v1.8H3.5v1.8H3.4c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h1.8H5.3z
        M5.3,21.1H7v1.8H5.3V21.1z"/>
      <path d="M42.1,30c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2h1.8h1.8v0.9
        c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.9h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2
        h-1.8v-1.8h1.8v-1.8h-1.8h-1.8v-1.8v-1.8h-1.8h-1.8h-1.8v1.8v1.8v1.8H42c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4
        c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h1.8V30z"/>
      <path d="M55.3,29.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9
        C56.2,30.2,55.8,29.9,55.3,29.9z"/>
      <path d="M1.8,31.6H1.6c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4C0,32.4,0,32.6,0,33.2v0.2v0.2
        c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v-1.8V31.6z"/>
      <path d="M68.6,32.8c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v1.8v1.8h-1.8v-0.2c0-0.6,0-0.8-0.1-1.1
        c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4
        C65,37.6,65,37.9,65,38.5v0.2v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v-1.8h1.8h1.8h0.2
        c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4C72,37.9,72,37.6,72,37v-0.2v-1.8v-1.8v-0.2c0-0.6,0-0.8-0.1-1.1
        c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2h-1.8v0.2C68.5,32.3,68.5,32.6,68.6,32.8z"/>
      <path d="M25.1,33.5c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h1.8v-1.8h-0.2
        C25.6,33.4,25.3,33.4,25.1,33.5z"/>
      <path d="M34.2,35.1c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9C33.4,34.7,33.8,35.1,34.2,35.1z"/>
      <rect x="1.8" y="35.1" width="1.8" height="1.8"/>
      <path d="M12.2,35.7c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v1.8h1.8v-0.2
        C12.3,36.2,12.3,35.9,12.2,35.7z"/>
      <path d="M0,37.8c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-0.9H0.9C0.4,36.9,0,37.3,0,37.8z"/>
      <polygon points="10.5,36.9 8.8,36.9 8.8,38.6 8.8,40.4 10.5,40.4 12.3,40.4 12.3,38.6 10.5,38.6 	"/>
      <path d="M34.2,36.9c-0.5,0-0.9,0.4-0.9,0.9v0.9h1.8v-0.9C35.1,37.3,34.7,36.9,34.2,36.9z"/>
      <path d="M31.6,38.6v-1.8V36c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.9h-1.8v-0.2c0-0.6,0-0.8-0.1-1.1
        c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v1.8h-1.8v-1.8h-1.8h-1.8v1.8h-1.8v-1.8h1.8v-1.8v-1.8h-1.8v-1.8h-1.8
        h-1.8V30c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v1.8v1.8h-0.2c-0.6,0-0.8,0-1.1,0.1
        c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2H14h-1.8v1.8H14h1.8v1.8h1.8h1.8v-1.8h1.8v1.8h1.8v-1.8h1.8v1.8h-1.8v0.2
        c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2h1.8h0.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9
        h-0.9v-1.8h1.8h1.8v1.8v0.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.9h1.8v-1.8H31.6z"/>
      <polygon points="12.3,40.4 12.3,42.1 14,42.1 15.8,42.1 15.8,40.4 14,40.4 	"/>
      <path d="M19.3,41.3c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.9h-1.8V41.3z"/>
      <path d="M68.5,42.1v1.8h-1.8v1.8h1.8h1.8v-1.8h0.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9V42
        c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2h-1.8v1.8H68.5z"/>
      <path d="M17.6,43.9v-0.2c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v1.8H17.6z"/>
      <path d="M61.3,42.1c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2H58h-1.8v1.8v1.8h0.2
        c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h1.8v0.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9
        v-0.9h1.8v-1.8H65h1.8v-1.8H65h-1.8V42c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v1.8H61.3z"/>
      <path d="M42.1,43.9v-0.2c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2h-0.2
        c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4
        c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h1.8h1.8h1.8h1.8v-1.8H42.1z"/>
      <path d="M49.2,43.9h1.8v1.8v1.8h1.8h1.8v-1.8v-1.8h1.8v-0.2c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4
        c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v-1.8v-1.8h-1.8v-1.8v-1.8v-0.9c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.9v1.8h-1.8v-0.2
        c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2h-1.8v-0.9c0-0.5-0.4-0.9-0.9-0.9
        c-0.5,0-0.9,0.4-0.9,0.9v0.9h-1.8h-1.8v-1.8v-1.8v-1.8h-1.8v-0.2c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4
        c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v-0.2c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v-0.9
        c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9v0.9v1.8h-1.8v-0.9c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.9v1.8h-1.8h-1.8h-1.8
        v-1.8v-1.8h-1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h-1.8v1.8h1.8v1.8h1.8h1.8h1.8
        v1.8h1.8h1.8H30c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h0.2c0.6,0,0.8,0,1.1-0.1
        c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h1.8V30c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4
        c0.2,0.1,0.5,0.1,1.1,0.1h0.2h1.8v1.8v1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2v1.8
        h-1.8v1.8h-1.8v1.8v1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h1.8h1.8v-1.8v-1.8h0.2
        c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2H37c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4
        c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h1.8h1.8h1.8v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v-1.8
        v-1.8h1.8v1.8v1.8h1.8v-1.8h1.8v1.8h1.8v1.8h-1.8v-1.8h-1.8v1.8h-1.8v-1.8h-1.8v1.8h-0.2c-0.6,0-0.8,0-1.1,0.1
        c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h1.8h1.8v1.8h-1.8h-1.8v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4
        c0.2,0.1,0.5,0.1,1.1,0.1h0.2h1.8h1.8v-1.8V43.9z"/>
      <path d="M12.3,46.5c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.9h1.8V46.5z"/>
      <path d="M17.6,45.8c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v-1.8h1.8v1.8h1.8h1.8
        h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h0.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9
        h-0.9h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h-1.8v-0.2c0-0.6,0-0.8-0.1-1.1
        c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2h-1.8h-1.8v1.8V45.8z"/>
      <path d="M29.9,46.5c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.9h-0.9C30.2,45.7,29.9,46.1,29.9,46.5z"/>
      <path d="M35.1,46.5c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-0.9h-1.8V46.5z"/>
      <path d="M63.2,45.7v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1H65h0.2
        c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2H65H63.2z"/>
      <path d="M71.1,47.4c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9v1.8H71.1z"/>
      <path d="M19.3,49.2h-1.8h-1.8v1.8v1.8v1.8h1.8v1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4
        c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h1.8v1.8V58h1.8H23c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2v-1.8
        v-1.8v-1.8h-1.8v-0.2c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v-1.8h-1.8V49.2z M21.1,52.7
        h-1.8h-1.8v-1.8h1.8h1.8V52.7z"/>
      <rect x="49.2" y="47.4" width="1.8" height="1.8"/>
      <path d="M69,47.5c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h-1.8h-0.2c-0.6,0-0.8,0-1.1,0.1
        c-0.2,0.1-0.3,0.2-0.4,0.4C65,49.9,65,50.2,65,50.8v0.2h1.8v1.8v1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4
        C65,55.2,65,55.5,65,56v0.2h1.8h1.8v-1.8h1.8v1.8h-1.8V58v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4
        c0.2,0.1,0.5,0.1,1.1,0.1h0.2v1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h1.8V65h0.2
        c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2v-1.8v-1.8V58v-1.8v-1.8v-1.8v-0.2c0-0.6,0-0.8-0.1-1.1
        c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v-1.8v-1.8h-0.2C69.5,47.4,69.2,47.4,69,47.5z"/>
      <path d="M26.3,50c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.9h1.8V50z"/>
      <path d="M52.7,50c0-0.5-0.4-0.9-0.9-0.9h-0.9v1.8h0.9C52.3,50.9,52.7,50.5,52.7,50z"/>
      <path d="M63.2,50c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.9h1.8V50z"/>
      <path d="M14,50.9v-1.8h1.8v-1.8v-1.8v-1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4
        C14,44.7,14,44.9,14,45.5v0.2v1.8h-1.8v1.8h-1.8v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v1.8
        h-1.8H8.8H7H5.3v-1.8H3.5v-1.8h1.8v1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4C7,50.2,7,49.9,7,49.3v-0.2h1.8h1.8v-1.8
        H8.8v-1.8v-1.8h1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h-1.8H8.8v-1.8H7v1.8H5.3v-1.8H7
        v-1.8v-1.8h1.8v-1.8H7V35c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1H5.3H5.1c-0.6,0-0.8,0-1.1,0.1
        c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h1.8v1.8H3.5v1.8v1.8H1.8H1.6c-0.6,0-0.8,0-1.1,0.1
        c-0.2,0.1-0.3,0.2-0.4,0.4C0,41.2,0,41.4,0,42v0.2v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2
        h1.8h1.8v1.8H7v1.8H5.3v-1.8H5.1c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2H1.8H1.6
        c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4C0,48.2,0,48.5,0,49v0.2v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4
        c0.2,0.1,0.5,0.1,1.1,0.1h0.2v1.8H1.6c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4C0,53.4,0,53.7,0,54.3v0.2v0.9
        c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-0.9h1.8v1.8v0.9c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-0.9h0.2c0.6,0,0.8,0,1.1-0.1
        c0.2-0.1,0.3-0.2,0.4-0.4C7,55.4,7,55.2,7,54.6v-0.2h1.8v1.8v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4
        C9.5,58,9.8,58,10.4,58h0.2h0.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9v-1.8h1.8H14v-1.8V50.9z"/>
      <path d="M26.5,52.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v1.8h1.8h0.9c0.5,0,0.9-0.4,0.9-0.9
        c0-0.5-0.4-0.9-0.9-0.9h-0.9v-1.8V50c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.9h-1.8v0.2C26.3,51.6,26.3,51.9,26.5,52.1z"
        />
      <path d="M34.2,50.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9v-0.9C35.1,51.3,34.7,50.9,34.2,50.9z"/>
      <path d="M42.1,51.1c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2h1.8h1.8h1.8v0.2
        c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2h1.8h1.8v1.8h1.8v-1.8v-1.8v-1.8v-1.8v-1.8h-1.8v1.8v1.8
        v1.8h-1.8h-1.8v-1.8h-1.8v-1.8h-1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h-1.8v-0.2
        c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v-0.9c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9
        v0.9v1.8h1.8V51.1z"/>
      <path d="M59.7,50.9h-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9h1.8v-1.8H59.7z"/>
      <path d="M63.2,52.7h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h-1.8V52.7z"/>
      <path d="M61.5,53.6c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.9h-1.8V53.6z"/>
      <path d="M26.3,55.3c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.9h-0.9C26.7,54.4,26.3,54.8,26.3,55.3z"/>
      <path d="M42,55c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2v-1.8v-1.8h-1.8h-0.2c-0.6,0-0.8,0-1.1,0.1
        c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h-1.8v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4
        c0.2,0.1,0.5,0.1,1.1,0.1h0.2h1.8v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2h1.8V56
        C42.1,55.5,42.1,55.2,42,55z"/>
      <path d="M44.8,54.4c-0.5,0-0.9,0.4-0.9,0.9v0.9h1.8v-0.9C45.7,54.8,45.3,54.4,44.8,54.4z"/>
      <path d="M17.6,58v-1.8h-1.8v-1.8H14v1.8V58v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1
        h0.2V58H17.6z"/>
      <path d="M42.1,58h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h-1.8V58z"/>
      <path d="M52.7,56.2h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1V58h-1.8v-0.2
        c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2h-1.8v0.2c0,0.6,0,0.8,0.1,1.1
        c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1
        h0.2h1.8v1.8v0.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.9v-1.8V58h1.8v-1.8H52.7z"/>
      <path d="M17.6,58v1.8h1.8v1.8h1.8H22c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9V58h-1.8H17.6z"/>
      <path d="M40.9,58.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2v1.8h-1.8v0.2c0,0.6,0,0.8,0.1,1.1
        c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1
        v-0.2H43c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9V58H42C41.4,58,41.2,58,40.9,58.1z"/>
      <path d="M11.7,59.8c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2H8.8H7H5.3H3.5H1.8H1.6c-0.6,0-0.8,0-1.1,0.1
        c-0.2,0.1-0.3,0.2-0.4,0.4C0,60.5,0,60.7,0,61.3v0.2v1.8V65v1.8v1.8v1.8v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4
        C0.8,72,1,72,1.6,72h0.2h1.8h1.8H7h1.8h1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2v-1.8
        v-1.8V65v-1.8v-1.8v-0.2c0-0.6,0-0.8-0.1-1.1C12.1,60.1,11.9,59.9,11.7,59.8z M10.5,63.2V65v1.8v1.8v1.8H8.8H7H5.3H3.5H1.8v-1.8
        v-1.8V65v-1.8v-1.8h1.8h1.8H7h1.8h1.8V63.2z"/>
      <path d="M17.6,59.7h-1.8v1.8h-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9h1.8V65h-0.2c-0.6,0-0.8,0-1.1,0.1
        c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2v1.8v1.8v0.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.9h0.2
        c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h1.8v-1.8h-1.8V65v-1.8v-1.8h-1.8V59.7z"/>
      <path d="M38.5,60.3c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2h-1.8h-1.8V58h1.8H36
        c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9h-1.8h-1.8h-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9v1.8h-0.2
        c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h-1.8v-0.2c0-0.6,0-0.8-0.1-1.1
        c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4
        c-0.1,0.2-0.1,0.5-0.1,1.1v0.2v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2h1.8h1.8h1.8v-1.8h1.8
        v1.8h1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h1.8v-0.2C38.6,60.7,38.6,60.5,38.5,60.3z"
        />
      <path d="M60.6,59.7c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9
        C61.5,60.1,61.1,59.7,60.6,59.7z"/>
      <path d="M8.2,63.3c-0.2-0.1-0.5-0.1-1.1-0.1H7H5.3H5.1c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4
        c-0.1,0.2-0.1,0.5-0.1,1.1V65v1.8v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2H7h0.2
        c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2V65v-0.2c0-0.6,0-0.8-0.1-1.1
        C8.6,63.6,8.4,63.4,8.2,63.3z"/>
      <path d="M31.6,65h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h-1.8V65z"/>
      <path d="M47.4,64.1c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9V65h0.9C47,65,47.4,64.6,47.4,64.1z"/>
      <path d="M66.7,63.2H65v-1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2v-0.2
        c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4C66,58,65.7,58,65.1,58H65v-1.8h-1.8h-1.8h-1.8v-0.9c0-0.5-0.4-0.9-0.9-0.9
        c-0.5,0-0.9,0.4-0.9,0.9v0.9h-1.8V58h-1.8v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2v1.8H56
        c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4
        C55.2,65,55.5,65,56,65h0.2v1.8v0.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.9h1.8V65h1.8h1.8H65h1.8h1.8v-1.8H66.7z
        M61.5,63.2h-1.8H58v-1.8v-1.8V58h1.8h1.8h1.8v1.8v1.8v1.8H61.5z"/>
      <path d="M30.4,65.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2v1.8v1.8H29c-0.5,0-0.9,0.4-0.9,0.9
        c0,0.5,0.4,0.9,0.9,0.9h0.9h1.8h1.8h1.8h1.8H37c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h1.8v0.9
        c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.9h1.8h1.8v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4
        c0.2,0.1,0.5,0.1,1.1,0.1h0.2h0.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9v-0.2c0-0.6,0-0.8-0.1-1.1
        c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2h-1.8h-1.8v-1.8h1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4
        c0.1-0.2,0.1-0.5,0.1-1.1V65h-1.8h-1.8H42c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.5-0.1,1.1v0.2v1.8h-1.8
        h-1.8v-1.8h0.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4
        c-0.1,0.2-0.1,0.5-0.1,1.1v0.2v1.8h-1.8v1.8h-1.8v-1.8h1.8v-0.2c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4
        c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2V65h-0.2C30.9,65,30.6,65,30.4,65.1z"/>
      <path d="M68.5,65.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9V65h-1.8V65.9z"/>
      <path d="M22.8,68.5h1.8h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h0.9
        c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9h-1.8h-1.8h-0.2c-0.6,0-0.8,0-1.1,0.1c-0.2,0.1-0.3,0.2-0.4,0.4
        c-0.1,0.2-0.1,0.5-0.1,1.1v0.2h1.8V68.5z"/>
      <path d="M53.6,66.7h-0.9v-0.9c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.9v0.2c0,0.6,0,0.8,0.1,1.1
        c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.5,0.1,1.1,0.1h0.2h0.9c0.5,0,0.9-0.4,0.9-0.9C54.4,67.1,54,66.7,53.6,66.7z"/>
      <path d="M66.7,67.6c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.9h1.8V67.6z"/>
      <path d="M21.1,70.2v0.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.9v-1.8h-1.8V70.2z"/>
      <path d="M59.7,70.2h1.8v-1.8h1.8v-0.2c0-0.6,0-0.8-0.1-1.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1h-0.2
        h-1.8v1.8V70.2z"/>
      <rect x="63.2" y="68.5" width="1.8" height="1.8"/>
      <path d="M25.5,70.2c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9
        C26.3,70.6,25.9,70.2,25.5,70.2z"/>
      <path d="M53.6,70.2h-0.9h-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.9h0.9c0.5,0,0.9-0.4,0.9-0.9
        C54.4,70.6,54,70.2,53.6,70.2z"/>
      <path d="M57.1,70.2c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9H58h0.2c0.6,0,0.8,0,1.1-0.1c0.2-0.1,0.3-0.2,0.4-0.4
        c0.1-0.2,0.1-0.5,0.1-1.1v-0.2H58H57.1z"/>
      <path d="M61.5,71.1c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.9h-1.8V71.1z"/>
      <path d="M65,70.2v0.2c0,0.6,0,0.8,0.1,1.1c0.1,0.2,0.2,0.3,0.4,0.4C65.7,72,66,72,66.6,72h0.2h0.2c0.6,0,0.8,0,1.1-0.1
        c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.5,0.1-1.1v-0.2h1.8h0.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-0.9h-1.8h-1.8v1.8
        H65z"/>
    </g>
  </svg>
);


const Background:React.FunctionComponent<{}> = () => {
  const parallaxRef = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const parallaxInstance = new Parallax(parallaxRef.current as HTMLElement, {
      scalarY: 3
    });
    if (window.innerWidth <= 767 && parallaxRef && parallaxRef.current) {
      parallaxRef.current.style.transform = `scale(${window.innerWidth / 560})`;
    }
    parallaxInstance.enable();
    window.addEventListener("resize", (e) => {
      const { innerWidth: width } = window;
      if (parallaxRef && parallaxRef.current && width <= 767) {  
        const scale = width / 560;
        parallaxRef.current.style.transform = `scale(${scale})`;
      }
    })

    return () => {
      parallaxInstance.destroy();
    };
  }, [])
  return <div className="background" id="parallax-scene" ref={parallaxRef as React.RefObject<HTMLDivElement>}>
    <div data-depth="0.3" className="parallax-circle">
      <svg className="circle" width="1086" height="1106" viewBox="0 0 1086 1106" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_f_295_245)">
          <ellipse cx="542.857" cy="552.542" rx="342.857" ry="352.542" fill="url(#paint0_linear_295_245)"/>
        </g>
        <defs>
          <filter id="filter0_f_295_245" x="0" y="0" width="1085.71" height="1105.08" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_295_245"/>
          </filter>
          <linearGradient id="paint0_linear_295_245" x1="270.879" y1="248.588" x2="766.652" y2="891.827" gradientUnits="userSpaceOnUse">
            <stop stopColor="#3D53C1"/>
            <stop offset="1" stopColor="#B3BEF5" stopOpacity="0"/>
          </linearGradient>
        </defs>
      </svg>
    </div>
    {isSafari
    ? <div data-depth="0.6" className="parallax-triangle">
      <svg className="triangle" width="1036" height="981" viewBox="0 0 1036 981" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_f_295_247)">
      <path d="M499.945 166L798.771 698.203H201.119L499.945 166Z" fill="#31408E"/>
      </g>
      <defs>
      <filter id="filter0_f_295_247" x="51.1188" y="16" width="897.653" height="832.203" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
      <feFlood floodOpacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="75" result="effect1_foregroundBlur_295_247"/>
      </filter>
      </defs>
      </svg>
    </div>
    : <div data-depth="0.6" className="parallax-triangle">
      <svg className="triangle" width="1036" height="981" viewBox="0 0 1036 981" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_f_295_247)">
      <path d="M499.945 166L798.771 698.203H201.119L499.945 166Z" fill="url(#paint0_linear_295_247)"/>
      </g>
      <defs>
      <filter id="filter0_f_295_247" x="51.1188" y="16" width="897.653" height="832.203" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
      <feFlood floodOpacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="75" result="effect1_foregroundBlur_295_247"/>
      </filter>
      <linearGradient id="paint0_linear_295_247" x1="499.945" y1="166" x2="499.945" y2="875.605" gradientUnits="userSpaceOnUse">
      <stop stopColor="#667CEA"/>
      <stop offset="1" stopColor="#4963E6"/>
      </linearGradient>
      </defs>
      </svg>
    </div>}
  </div>
}

const Card = ({
  className,
  title,
  value,
  desc,
  type
} : {
  className?: string,
  title?: ReactNode,
  value?: ReactNode,
  desc?: ReactNode
  type?: undefined | "alt"
}) => (
  <div className={cnb("card", className)}>
    <div className={cnb("card-title", "paragraph", "paragraph-medium")}>{title}</div>
    {type
      ? <div className={cnb("card-value", "title", "title-large")}>{value}</div>
      : <div className={cnb("card-value", "title", "title-huge")}>{value}</div>
    }
    <div className={cnb("card-decs", "title", "title-medium")}>{desc}</div>
  </div>
  );

export const Token:React.FunctionComponent<{}> = () => {

  const [showTable, setShowTable] = useState<boolean>(false);
  const [info, setInfo] = useState<Info>();

  const [endOfDay, setEndOfDay] = useState<number>(0);
  const [duration, setDuration] = useState<moment.Duration>();

  const ref1 = useRef<SVGSVGElement>(null);
  const ref2 = useRef<SVGSVGElement>(null);

  const timetable = [
    {date: "15—20", price: "$0.20", malloc: "100,000"},
    {date: "21", price: "$0.21", malloc: "80,000"},
    {date: "22", price: "$0.22", malloc: "60,000"},
    {date: "23", price: "$0.23", malloc: "40,000"},
    {date: "24", price: "$0.24", malloc: "20,000"},
    {date: "25", price: "$0.25", malloc: "10,000"},
    {date: "26", price: "$0.26", malloc: "8,000"},
    {date: "27", price: "$0.27", malloc: "6,000"},
    {date: "28", price: "$0.28", malloc: "4,000"},
    {date: "29", price: "$0.29", malloc: "2,000"},
    {date: "30", price: "$0.30", malloc: "1,000"},
  ]

  useEffect(() => {
    if (isMobile) {
      if (ref1.current) {
        // Bind the event listener
        ref1.current.addEventListener("click", ((event: CustomEvent) => {
          setShowTable(!showTable);
        }) as (event: Event) => void);
      }
      if (ref2.current) {
        // Bind the event listener
        ref2.current.addEventListener("click", ((event: CustomEvent) => {
          setShowTable(!showTable);
        }) as (event: Event) => void);
      }
    } else {
      if (ref1.current) {
        // Bind the event listener
        ref1.current.addEventListener("mouseenter", ((event: CustomEvent) => {
          setShowTable(true);
        }) as (event: Event) => void);
        ref1.current.addEventListener("mouseleave", ((event: CustomEvent) => {
          setShowTable(false);
        }) as (event: Event) => void);
      }
      if (ref2.current) {
        // Bind the event listener
        ref2.current.addEventListener("mouseenter", ((event: CustomEvent) => {
          setShowTable(true);
        }) as (event: Event) => void);
        ref2.current.addEventListener("mouseleave", ((event: CustomEvent) => {
          setShowTable(false);
        }) as (event: Event) => void);
      }
    }
    return () => {
      if (isMobile) {
        if (ref1.current) {
          // Unbind the event listener on clean up
          ref1.current.removeEventListener("click", ((event: CustomEvent) => {
            setShowTable(!showTable);
          }) as (event: Event) => void);
        }
        if (ref2.current) {
          // Unbind the event listener on clean up
          ref2.current.removeEventListener("click", ((event: CustomEvent) => {
            setShowTable(!showTable);
          }) as (event: Event) => void);
        }
      } else {
        if (ref1.current) {
          // Unbind the event listener on clean up
          ref1.current.removeEventListener("mouseenter", ((event: CustomEvent) => {
            setShowTable(true);
          }) as (event: Event) => void);
          ref1.current.removeEventListener("mouseleave", ((event: CustomEvent) => {
            setShowTable(false);
          }) as (event: Event) => void);
        }
        if (ref2.current) {
          // Unbind the event listener on clean up
          ref2.current.removeEventListener("mouseenter", ((event: CustomEvent) => {
            setShowTable(true);
          }) as (event: Event) => void);
          ref2.current.removeEventListener("mouseleave", ((event: CustomEvent) => {
            setShowTable(false);
          }) as (event: Event) => void);
        }
      }
    };
  }, [ref1, ref2]);

  useEffect(() => {
    console.log(showTable);
    return () => {
    };
  }, [showTable]);

  useEffect(() => {
    if (!info) {
      DeBotClient.getInfo()
        .then((value: any) => {
          console.log(value);
          setInfo(value.info);
        });
    }
  }, [info]);

  useEffect(() => {
    setEndOfDay(moment().utc().endOf("day").unix());
    return () => {}
  }, []);

  useEffect(() => {
    const mmnt = moment;
    const currentTime = mmnt().utc().unix();
    const diffTime = endOfDay - currentTime;
    let duration = moment.duration(diffTime * 1000, 'milliseconds');
    const interval:any = setInterval(() => {
      duration = moment.duration(duration.subtract(1000, 'milliseconds'), 'milliseconds');
      if (duration.asMilliseconds() < 1000) {
        setTimeout(() => setEndOfDay(moment().utc().endOf("day").unix()), 1000);
        setInfo(undefined);
        DeBotClient.getInfo()
        .then((value: any) => {
          console.log(value);
          setInfo(value.info);
        });
      }
      setDuration(duration);
      //countdown.innerText = duration.hours() + ":" + duration.minutes() + ":" + duration.seconds()
    }, 1000);
    return () => {clearInterval(interval)}
  }, [endOfDay]);

  useEffect(() => {
    if (info && ((parseFloat(info?.usdPrice) / (10**6)) !== 0.3)) {
      setTomorrowPrice(timetable[1 + timetable.findIndex((day) => parseFloat(day.price.substr(1)) === parseFloat(info?.usdPrice) / (10**6))].price);
    } else {
      setTomorrowPrice("0.3");
    }
  }, [info]);

  const [toast, setToast] = useState<boolean>(true);
  const [tomorrowPrice, setTomorrowPrice] = useState<string>("");



    return (
      <>
      <MetaDecorator
        title="$SURF utility token · Ever Surf"
        description="Bridge between users and service providers at Everscale."
        keywords="ever, surf, token, everscale, utility, bridge, ever, blockchain, community"
      />
      {/* <Toast
        header={<div className="title title-small2">
          <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 13.7142V6.00254C14 6.00163 13.9989 6.00119 13.9983 6.00185L10 10.2858V17.9975C10 17.9984 10.0011 17.9988 10.0017 17.9981L14 13.7142Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
            <path d="M21 13.7142V6.00254C21 6.00163 20.9989 6.00119 20.9983 6.00185L17 10.2858V17.9975C17 17.9984 17.0011 17.9988 17.0017 17.9981L21 13.7142Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
            <path d="M7 13.7142V6.00254C7 6.00163 6.99889 6.00119 6.99827 6.00185L3 10.2858V17.9975C3 17.9984 3.00111 17.9988 3.00173 17.9981L7 13.7142Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
          </svg>Web 3.0 compatible</div>
        }
        qrcode={<DebotQrCode/>}
        close={true}
        variant={"dark"}
        show={toast}
        onClose={() => {setToast(false)}}
      >
        <a href="https://uri.ever.surf/debot/0:be358a444895ed16532a3ec901ea25d6f1f766bf5921833e4cec87f8b8dd7aba" rel="noopener noreferrer nofollow" target="_blank">
          <div className="action action-normal">Ever Surf Token Debot</div>
          <div className="parapgraph parapgraph-small">Address: 0:be3 ···· 7aba</div>
        </a>
      </Toast> */}
      <Container fluid>
        <Row className="hero">
          <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1 }} md={{ span: 12, order: 1 }} lg={{ span: 12 }} xl={{ span: 12 }}>
            <h1 className="header title title-great">$SURF is a utility token of the Ever Surf ecosystem designed as a bridge between users and service providers</h1>
            {/* <FlexContainer
              className={cnb("flex-info", "flex-info-top")}
              direction={"row"}
              justify={"flex-start"}
              align={"flex-start"}
            >
              <Flex>
                <Card
                  title={"Tokens left"}
                  value={info ? (10000000 - parseFloat(info?.totalTokens)).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) : <LoaderDots/>}
                />
              </Flex>

              <Flex>
                <Card
                  title={"Current price"}
                  value={info ? "$" + parseFloat(info?.usdPrice) / 10**6 : <LoaderDots/>}
                />
              </Flex>
            </FlexContainer>


            <FlexContainer
              className={cnb("flex-large", "button-row")}
            >
              <Flex>
                <a href="https://uri.ever.surf/debot/0:be358a444895ed16532a3ec901ea25d6f1f766bf5921833e4cec87f8b8dd7aba" rel="noreferrer" target="_blank">
                  <Button
                    size={"large"}
                    color="primary"
                  >
                    Join token sale
                  </Button>
                </a>
              </Flex>
              <Flex>
                <a href="https://ever.surf/token/SURF-Token.pdf" rel="noreferrer" target="_blank">
                  <Button
                    size={"large"}
                    color="default"
                    iconLeft={{
                      icon: <Icon icon={"download"} />,
                      animation: "left"
                    }}
                    iconRight={{
                      icon: <Icon icon={"download"} />,
                      animation: "left"
                    }}
                  >
                    SURF Token
                  </Button>
                </a>
              </Flex>
              <Flex>
                <a href="https://ever.surf/token/Ever-Surf-Pitch-Deck.pdf" rel="noreferrer" target="_blank">
                  <Button
                    size={"large"}
                    color="default"
                    iconLeft={{
                      icon: <Icon icon={"download"} />,
                      animation: "left"
                    }}
                  >
                    SURF Pitch Deck
                  </Button>
                </a>
              </Flex>
            </FlexContainer>
            <FlexContainer
              className={"flex-small"}
              direction="column"
              justify="flex-start"
              align-items="stretch"
            >
              <Flex>
                <a href="https://uri.ever.surf/debot/0:be358a444895ed16532a3ec901ea25d6f1f766bf5921833e4cec87f8b8dd7aba" rel="noreferrer" target="_blank"><Button size={"large"} color="primary">Join token sale</Button></a>
              </Flex>
              <Flex>
              <a href="https://ever.surf/token/SURF-Token.pdf" rel="noreferrer" target="_blank"><Button size={"large"} color="default" iconLeft={{icon: <Icon icon={"download"} />, animation: "left"}}>SURF Token</Button></a>
              </Flex>
              <Flex>
              <a href="https://ever.surf/token/Ever-Surf-Pitch-Deck.pdf" rel="noreferrer" target="_blank"><Button size={"large"} color="default" iconLeft={{icon: <Icon icon={"download"} />, animation: "left"}}>SURF Pitch Deck</Button></a>
              </Flex>
            </FlexContainer> */}
          </Col>
        </Row>
      </Container>
      {/* <Container fluid>
        <h3 className="title title-huge">Token sale stages</h3>
        <Row className={cnb("prices")}>
          <Col xs={{ span: 12, order: 1 }} sm={{ span: 6, order: 1 }} md={{ span: 6, order: 1 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Panel type="token">
              <h6 className="header title title-large">Seed<sup className="title title-medium color-green">Sold out</sup></h6>
              <FlexContainer
                className={cnb("")}
                direction={"column"}
                justify={"flex-start"}
                align={"stretch"}
              >
                <Flex>
                  <Card
                    title={"Target"}
                    value={"$2,000,000"}
                    desc={"20,000,000 SURF"}
                  />
                </Flex>
                <Flex>
                  <Card
                    title={"Price"}
                    value={"$0.1"}
                  />
                </Flex>
                <Flex>
                  <Card
                    title={"Min. allocation"}
                    value={"100,000 SURF"}
                    type="alt"
                  />
                </Flex>
                <Flex>
                  <div className={cnb("card", "card-last")}>
                    <div className={cnb("card-title", "title", "title-large")}>Lockup</div>
                    <div className={cnb("paragraph", "paragraph-medium")}>24 month lockup followed by a 12 month linear release</div>
                  </div>
                </Flex>
                <Flex>
                  <Button size={"large"} color="default" disabled={true}>Seed sale finished</Button>
                </Flex>
              </FlexContainer>
            </Panel>
          </Col>
          <Col xs={{ span: 12, order: 1 }} sm={{ span: 6, order: 1 }} md={{ span: 6, order: 1 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Panel
              type="token"
              className={cnb("panel-with-overlay")}
            >
              {isMobile 
                ? 
                <Overlay
                  show={showTable}
                  onHide={() => {}}
                  // size={"large"}
                  className={cnb("table-modal")}
                  body={<>
                    <div className={"table"}>
                      <div className={"thead"}>
                        <div className={"tr paragraph paragraph-small"}>
                          <div className={cnb("th")}>March</div>
                          <div className={cnb("th")}>Price</div>
                          <div className={cnb("th")}>Min. allocation</div>
                        </div>
                      </div>
                      <div className={cnb("tbody paragraph paragraph-normal")}>
                        {timetable
                        .map((element, index, obj) => {
                          return <div
                            key={index}
                            className={`tr`}>
                            <div className={"td"}>{element.date}</div>
                            <div className={"td"}>{element.price}</div>
                            <div className={"td"}>{element.malloc}</div>
                          </div>
                        })}
                      </div>
                    </div>
                    <Button
                      size={"large"}
                      color="default"
                      iconLeft={{
                        icon: <Icon icon={"close"} />,
                        animation: "left"
                      }}
                      onClick={() => setShowTable(false)}
                    >
                      Close
                    </Button>
                    </>}
                >
                </Overlay>
                : <div className={cnb("table-overlay", {"active": showTable})}>
                <div className={"table"}>
                  <div className={"thead"}>
                    <div className={"tr paragraph paragraph-small"}>
                      <div className={cnb("th")}>March</div>
                      <div className={cnb("th")}>Price</div>
                      <div className={cnb("th")}>Min. allocation</div>
                    </div>
                  </div>
                  <div className={cnb("tbody paragraph paragraph-normal")}>
                    {timetable
                    .map((element, index, obj) => {
                      return <div
                        key={index}
                        className={`tr`}>
                        <div className={"td"}>{element.date}</div>
                        <div className={"td"}>{element.price}</div>
                        <div className={"td"}>{element.malloc}</div>
                      </div>
                    })}
                  </div>
                </div>
              </div>
              }
              <h6 className="header title title-large">Strategic<sup className="title title-medium color-main-grad">15-30 March</sup></h6>
              <FlexContainer
                direction={"column"}
                justify={"flex-start"}
                align={"stretch"}
              >
                <Flex>
                  <Card
                    title={"Target"}
                    value={"$2,500,000"}
                    desc={"10,000,000 SURF"}
                  />
                </Flex>
                <Flex>
                  <Card
                    title={"Price"}
                    value={<span className={cnb("color-main-grad")}>$0.2→0.3<svg ref={ref1} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 15V12" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 9H12.01" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg></span>}
                  />
                </Flex>
                <Flex>
                  <Card
                    title={"Min. allocation"}
                    value={<span>100,000→1,000 SURF<svg ref={ref2} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 15V12" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 9H12.01" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg></span>}
                    type="alt"
                  />
                </Flex>
                <Flex>
                  <div className={cnb("card", "card-last")}>
                    <div className={cnb("card-title", "color-white", "title", "title-large")}>Lockup</div>
                    <div className={cnb("paragraph", "color-faded", "paragraph-medium")}>12 month lockup followed by a 24 month linear release</div>
                  </div>
                </Flex>
                <Flex>
                  <a href="https://uri.ever.surf/debot/0:be358a444895ed16532a3ec901ea25d6f1f766bf5921833e4cec87f8b8dd7aba" rel="noreferrer" target="_blank"><Button size={"large"} color="primary">Join token sale</Button></a>
                </Flex>
              </FlexContainer>
            </Panel>
          </Col>
          <Col xs={{ span: 12, order: 1 }} sm={{ span: 6, order: 1 }} md={{ span: 6, order: 1 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Panel type="token">
              <h6 className="header title title-large">Private<sup className="title title-medium">Coming soon</sup></h6>
              <FlexContainer
                direction={"column"}
                justify={"flex-start"}
                align={"stretch"}
              >
                <Flex>
                  <Card
                    title={"Target"}
                    value={"$3,300,000"}
                    desc={"10,000,000 SURF"}
                  />
                </Flex>
                <Flex>
                  <Card
                    title={"Price"}
                    value={"$0.3+"}
                  />
                </Flex>
                <Flex>
                  <Card
                    title={"Min. allocation"}
                    value={"1,000 SURF"}
                    type="alt"
                  />
                </Flex>
                <Flex>
                  <div className={cnb("card", "card-last")}>
                    <div className={cnb("card-title", "title", "title-large")}>Lockup</div>
                    <div className={cnb("paragraph", "paragraph-medium")}>12 month lockup followed by a 24 month linear release</div>
                  </div>
                </Flex>
                <Flex>
                  <Button size={"large"} color="default" disabled={true}>Join token sale</Button>
                </Flex>
              </FlexContainer>
            </Panel>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row className="stats">
          <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1 }} md={{ span: 12, order: 1 }} lg={{ span: 12 }} xl={{ span: 12 }}>
            <FlexContainer
              className={cnb("flex-info")}
              direction={"row"}
              justify={"flex-start"}
              align={"flex-start"}
            >
              <Flex>
                <Card
                  title={"$SURF total booked"}
                  value={info ? (20000000 + parseFloat(info?.totalTokens)).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) : <LoaderDots/>}
                />
              </Flex>

              <Flex>
                <Card
                  title={"Investors"}
                  value={info ? 16 + parseFloat(info?.totalOrders) : <LoaderDots/>}
                />
              </Flex>

              <Flex>
                <Card
                  title={"Left in the stage"}
                  value={info ? (10000000 - parseFloat(info?.totalTokens)).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) : <LoaderDots/>}
                />
              </Flex>

              <Flex>
                <Card
                  title={"Current price"}
                  value={info ? "$" + parseFloat(info?.usdPrice) / 10**6 : <LoaderDots/>}
                />
              </Flex>
            </FlexContainer>
          </Col>
        </Row>
      </Container> */}
      <Background />
      </>
    );
  };

export default Token;
